import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function CloseSection() {
  return <section className="py-32 bg-cream relative flex items-center justify-center text-center" data-id="element-36">
      <div className="container mx-auto px-6 max-w-2xl" data-id="element-37">
        <FadeIn data-id="element-38">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-charcoal leading-tight mb-8" data-id="element-39">
            Tu cuerpo no está roto.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-40">
          <p className="text-2xl md:text-3xl font-serif italic text-terracotta mb-8" data-id="element-41">
            Pero si no haces nada… nada va a cambiar.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-42">
          <p className="text-xl md:text-2xl text-charcoal-light font-medium" data-id="element-43">
            Y ahora tienes el mapa.
          </p>
        </FadeIn>
      </div>
    </section>;
}